import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import axios from "axios";
import {
  Button,
  Row,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  Col,
  Form,
  FormGroup,
} from "reactstrap";
import Swal from "sweetalert2";
import Baja from "../../Baja";
import Header from "../../../layout/Header/Header";

function ListadoCajas() {
  const { user } = useContext(AuthContext);
  const URL_CAJAS = import.meta.env.VITE_URL_CAJAS;
  const URL_AREAS = import.meta.env.VITE_URL_AREAS;
  const URL_LOGS = import.meta.env.VITE_URL_LOGS;

  const [cajas, setCajas] = useState([]);
  const [areas, setAreas] = useState([]);

  const [nombre, setNombre] = useState("");
  const [selectedArea, setSelectedArea] = useState("");

  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);

  const [idEdit, setIdEdit] = useState("");
  const [nombreEdit, setNombreEdit] = useState("");
  const [areaEdit, setAreaEdit] = useState("");
  const [isActiveEdit, setIsActiveEdit] = useState("");

  const [validaBoton, setValidaBoton] = useState(true);

  useEffect(() => {
    axios
      .get(URL_CAJAS, {
        headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
      })
      .then((res) => setCajas(res.data))
      .catch((err) => console.log(err));

    axios
      .get(URL_AREAS, {
        headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
      })
      .then((res) => setAreas(res.data))
      .catch((err) => console.log(err));
  }, []);

  function jalaInfo(id, nombre, area, is_active) {
    setIdEdit(id);
    setNombreEdit(nombre);
    setAreaEdit(area);
    setIsActiveEdit(is_active);
    toggle();
  }

  function saveCaja(event) {
    event.preventDefault();
    setValidaBoton(false);
    axios
      .post(
        URL_CAJAS,
        { nombre, areas: selectedArea },
        { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } }
      )
      .then(() => {
        axios.post(
          URL_LOGS,
          { tipo: "Crear Caja", detalle: nombre, user: user.id },
          { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } }
        );
        Swal.fire("Good job!", "Creado con exito", "success");
        setTimeout(() => window.location.reload(), 1000);
      })
      .catch((error) => {
        Swal.fire({ icon: "error", title: "Oops...", text: "Something went wrong!" });
        console.log(error);
        setValidaBoton(true);
      });
  }

  function editCaja(event) {
    event.preventDefault();
    axios
      .patch(
        `${URL_CAJAS}/${idEdit}`,
        { nombre: nombreEdit, areas: areaEdit, is_active: isActiveEdit },
        { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } }
      )
      .then(() => {
        axios.post(
          URL_LOGS,
          { tipo: "Editar Caja", detalle: nombreEdit, user: user.id },
          { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } }
        );
        toggle();
        Swal.fire("Good job!", "Actualizado con exito", "success");
        window.location.reload();
      })
      .catch((error) => {
        Swal.fire({ icon: "error", title: "Oops...", text: "Something went wrong!" });
        console.log(error);
      });
  }

  return (
    <>
      <Header />
      <br />
      <br />
      {user.menu_catalogos ? (
        <div className="container">
          <div className="row">
            <div className="col-md-7 col-sm-6">
              <div className="card">
                <div className="card-body">
                  <h3 align="center">Cajas</h3>
                  <Table size="sm" striped borderless className="table-responsive-xl">
                    <thead>
                      <tr>
                        <th className="tituloTabla">Nombre</th>
                        <th className="tituloTabla">Area</th>
                        <th className="tituloTabla">Activo</th>
                        <th className="tituloTabla">Editar</th>
                      </tr>
                    </thead>
                    <tbody>
                      {cajas
                        .sort((a, b) => (a.nombre > b.nombre ? 1 : -1))
                        .map((a) => (
                          <tr key={a._id}>
                            <td>{a.nombre}</td>
                            <td>{a.areas?.[0]?.name || ""}</td>
                            <td>{a.is_active}</td>
                            <td>
                              <Button
                                color="info"
                                size="sm"
                                onClick={() =>
                                  jalaInfo(a._id, a.nombre, a.areas?.[0]?._id || "", a.is_active)
                                }
                              >
                                <i className="far fa-edit"></i>
                              </Button>
                              <Baja
                                idStatus={a._id}
                                is_active={a.is_active}
                                URL_BAJA={URL_CAJAS}
                              />
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </Table>
                </div>
              </div>
            </div>

            <div className="col-md-5 col-sm-6">
              <div className="card">
                <div className="card-body">
                  <h3 align="center">Nueva Caja</h3>
                  <Form onSubmit={saveCaja}>
                    <FormGroup>
                      <Label>Nombre</Label>
                      <Input
                        type="text"
                        placeholder="Nombre de la caja"
                        value={nombre}
                        required
                        onChange={(e) => setNombre(e.target.value)}
                      />
                    </FormGroup>
                    <FormGroup>
                      <Label>Area</Label>
                      <Input
                        type="select"
                        value={selectedArea}
                        required
                        onChange={(e) => setSelectedArea(e.target.value)}
                      >
                        <option value="">Selecciona</option>
                        {areas
                          .filter((a) => a.esTienda === "Si")
                          .sort((a, b) => (a.name > b.name ? 1 : -1))
                          .map((a) => (
                            <option key={a._id} value={a._id}>{a.name}</option>
                          ))}
                      </Input>
                    </FormGroup>
                    <Row>
                      {validaBoton ? (
                        <Button type="submit" className="btn btn-success">Guardar</Button>
                      ) : (
                        <Button type="submit" className="btn btn-success" disabled>Guardar</Button>
                      )}
                      <Button href="/Catalogos" className="btn btn-danger" id="botonListado">
                        Regresar
                      </Button>
                    </Row>
                  </Form>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : undefined}

      <Modal size="sm" isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle}>Editar Caja</ModalHeader>
        <ModalBody>
          <Label>Nombre</Label>
          <Input
            type="text"
            value={nombreEdit}
            required
            onChange={(e) => setNombreEdit(e.target.value)}
          />
          <br />
          <Label>Area</Label>
          <Input
            type="select"
            value={areaEdit}
            required
            onChange={(e) => setAreaEdit(e.target.value)}
          >
            <option value="">Selecciona</option>
            {areas
              .filter((a) => a.esTienda === "Si")
              .sort((a, b) => (a.name > b.name ? 1 : -1))
              .map((a) => (
                <option key={a._id} value={a._id}>{a.name}</option>
              ))}
          </Input>
          <br />
          <Label>Activo</Label>
          <Input
            type="select"
            value={isActiveEdit}
            required
            onChange={(e) => setIsActiveEdit(e.target.value)}
          >
            <option value="Si">Si</option>
            <option value="No">No</option>
          </Input>
        </ModalBody>
        <ModalFooter>
          <Button color="success" onClick={editCaja}>Guardar</Button>
        </ModalFooter>
      </Modal>
    </>
  );
}

export default ListadoCajas;
